// import React, { useEffect } from 'react';
import BasicGrammarPdf from '../pdf/Basic Grammar and Usage.pdf'
import RecommendedTrainingOutlinePdf from '../pdf/RECOMMENDED TRAINING OUTLINE FOR REGULATORY WRITERS.pdf'
import MedicalEditingChecklistPdf from '../pdf/Medical Editing Checklist.pdf'
import ElementsofmedicalterminologyPdf from '../pdf/Elements of Medical Terminology Quick Reference Guide.pdf'
import ValueofmedicalwritingPdf from '../pdf/Value of Medical Writing The Regulators Perspective.pdf'
import MedicalCommunicationessentialPdf from '../pdf/Medical Communication Essential Skills for Success.pdf'
import IndustryNews from '../pdf/INDUSTRY NEWS.pdf'
import { useEffect, useState } from 'react'

const articles = [
    {
        title: 'Basic Grammar',
        pdf: BasicGrammarPdf,
    },
    {
        title: 'Recommended Training Outline',
        pdf: RecommendedTrainingOutlinePdf,
    },
    {
        title: 'Medical Editing Checklist',
        pdf: MedicalEditingChecklistPdf,
    },
    {
        title: 'Elements of Medical Terminology',
        pdf: ElementsofmedicalterminologyPdf,
    },
    {
        title: 'Value of Medical Writing',
        pdf: ValueofmedicalwritingPdf,
    },
    {
        title: 'Medical Communication Essential',
        pdf: MedicalCommunicationessentialPdf,
    },
    {
        title: 'Industry News',
        pdf: IndustryNews,
    },
];

// const EssentialforMedicalWriting = () => {
//     useEffect(() => {
//         const hash = window.location.hash;
//         if (hash) {
//             setTimeout(() => {
//                 const element = document.querySelector(hash);
//                 if (element) {
//                     element.scrollIntoView({ behavior: 'smooth' });
//                 }
//             }, 300);
//         }
//     }, []);

//     return (
//         <div className="about-ed-wrapper-impact">
//             <h2 className="about-ed-heading-impact">Essential for Medical Writing</h2>
//             <div className="about-ed-block-impact">
//                 <div className="about-ed-content-impact">
//                     <div className="current-issues-cards-impact">
//                         {articles.map((article, index) => (
//                             <div className="current-issue-card-impact" key={index}>
//                                 <div className="current-issue-card-right-impact">
//                                     <div className="current-issue-card-article-title">
//                                         <h3>{article.title}</h3>
//                                     </div>
//                                     <div className="current-issue-card-buttons">
//                                         <a
//                                             href={article.pdf}
//                                             target="_blank"
//                                             rel="noopener noreferrer"
//                                             className="download-current-issue-article"
//                                         >
//                                             View PDF
//                                         </a>
//                                     </div>
//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default EssentialforMedicalWriting;




const EssentialforMedicalWriting = () => {
    const [pdfToView, setPdfToView] = useState(null);

    // const articles = [
    //     { title: 'Basic Grammar', pdf: BasicGrammarPdf },
    //     { title: 'Recommended Training Outline', pdf: RecommendedTrainingOutlinePdf },
    //     { title: 'Medical Editing Checklist', pdf: MedicalEditingChecklistPdf },
    //     { title: 'Elements of Medical Terminology', pdf: ElementsofmedicalterminologyPdf },
    //     { title: 'Value of Medical Writing', pdf: ValueofmedicalwritingPdf },
    //     { title: 'Medical Communication Essential', pdf: MedicalCommunicationessentialPdf },
    //     { title: 'Industry News', pdf: IndustryNews },
    // ];

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            setTimeout(() => {
                const element = document.querySelector(hash);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 300);
        }
    }, []);

    return (
        <div className="about-ed-wrapper-impact">
            <h2 className="about-ed-heading-impact">Essential for Medical Writing</h2>
            <div className="about-ed-block-impact">
                <div className="about-ed-content-impact">
                    <div className="current-issues-cards-impact">
                        {articles.map((article, index) => (
                            <div className="current-issue-card-impact" key={index}>
                                <div className="current-issue-card-right-impact">
                                    <div className="current-issue-card-article-title">
                                        <h3>{article.title}</h3>
                                    </div>
                                    <div className="current-issue-card-buttons">
                                        <button
                                            className="download-current-issue-article"
                                            onClick={() => setPdfToView(article.pdf)}
                                        >
                                            View PDF
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* PDF Viewer Modal */}
            {pdfToView && (
                <div className="pdf-modal-overlay" onClick={() => setPdfToView(null)}>
                    <div className="pdf-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="pdf-close-btn" onClick={() => setPdfToView(null)}>
                            &times;
                        </button>
                        <iframe
                            src={`${pdfToView}#toolbar=0`}
                            title="PDF Viewer"
                            className="pdf-frame"
                            frameBorder="0"
                        ></iframe>
                    </div>
                </div>
            )}
        </div>
    );
};


export default EssentialforMedicalWriting;